import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setVisible(true);
    }
  }, []);

  const accept = () => {
    localStorage.setItem('cookie-consent', 'accepted');
    setVisible(false);
  };

  const refuse = () => {
    localStorage.setItem('cookie-consent', 'refused');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 border-t-2 border-primary bg-background shadow-lg">
      <div className="container mx-auto flex flex-col sm:flex-row items-center justify-between gap-3 sm:gap-8 px-4 sm:px-8 py-3">
        <p className="text-xs sm:text-sm text-muted-foreground text-center sm:text-left">
          Ce site utilise des cookies.{' '}
          <Link to="/politique-de-confidentialite" className="text-primary underline hover:text-primary/80">
            En savoir plus
          </Link>
        </p>
        <div className="flex shrink-0 gap-2">
          <Button variant="outline" className="h-8 px-4 text-xs rounded-md" onClick={refuse}>
            Refuser
          </Button>
          <Button className="h-8 px-4 text-xs rounded-md" onClick={accept}>
            Accepter
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
